import React, { createContext, useContext, useState } from "react";

export type PlanType = string | undefined;

interface PlanTypeContextProps {
  type: PlanType;
  setType: (type: PlanType) => void;
}

const PlanTypeContext = createContext<PlanTypeContextProps | undefined>(
  undefined
);

export const PlanTypeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [type, setType] = useState<PlanType>(undefined);
  return (
    <PlanTypeContext.Provider value={{ type, setType }}>
      {children}
    </PlanTypeContext.Provider>
  );
};

export const usePlanType = () => {
  const context = useContext(PlanTypeContext);
  if (!context) {
    throw new Error("usePlanType must be used within a PlanTypeProvider");
  }
  return context;
};
